// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1SrJW","buttons":"RemoveExpirationActionButtons_buttons__D74-H"};